import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costs } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-mist py-12 sm:py-14" aria-labelledby="problem-heading" data-id="element-180" data-mp="2lqgwkp38r9v5">
      <div className="mx-auto max-w-5xl px-6" data-id="element-181" data-mp="2vqhfwb141pzc">
        <SectionHeading eyebrow="El problema real" eyebrowTone="alert" title={<span id="problem-heading" data-id="element-183" data-mp="39hct1zin6t8q">La realidad del docente de Educación Física</span>} data-id="element-182" data-mp="2vppjixzovo80" />

        <div className="mx-auto mt-9 max-w-3xl space-y-5 border-l-2 border-green/50 pl-6 sm:pl-8" data-id="element-184" data-mp="35gkin2y1aiav">
          <p className="font-display text-xl font-bold leading-snug text-ink sm:text-[1.6rem]" data-id="element-185" data-mp="3jftob8om5u0l">
            Es domingo a la noche. Mañana tenés cinco cursos distintos, un patio
            compartido y una caja con tres conos y dos pelotas pinchadas. Y
            seguís sin saber qué vas a dar.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-muted" data-id="element-186" data-mp="1k3heg9r18qgp">
            Pasaste la tarde buscando actividades sueltas en YouTube y en grupos
            de Facebook, pegando ideas que no encajan entre sí. A mitad de la
            semana ya sabés cómo termina: no hay progresión real entre clases,
            los más grandes se aburren, los más chicos no entienden la consigna
            — y el lunes siguiente volvés a empezar de cero.
          </p>
        </div>

        <div className="mt-12" data-id="element-187" data-mp="123v4cam934fu">
          <h3 className="text-center font-display text-xl font-bold leading-snug text-ink sm:text-[1.6rem]" data-id="element-188" data-mp="122jqtj306ibj">
            El costo real de improvisar cada semana
          </h3>

          <ul className="mt-7 grid gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="1c199vf6my8td">
            {costs.map(cost => <li key={cost.title} className="flex gap-3" data-id="element-190" data-mp="1g3w41mqs45tq">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-alert/30 bg-alert-soft" aria-hidden="true" data-id="element-191" data-mp="1g19vbjs5jk9x">
                  <XIcon className="h-3 w-3 text-alert" strokeWidth={3} data-id="element-192" data-mp="3hvio14c970gp" />
                </span>
                <span data-id="element-193" data-mp="p1btq4fqzkx3">
                  <span className="block font-sans text-[0.9rem] font-semibold leading-snug text-ink" data-id="element-194" data-mp="p0itlmbantnx">
                    {cost.title}
                  </span>
                  <span className="mt-1.5 block font-sans text-[0.82rem] leading-relaxed text-muted" data-id="element-195" data-mp="y1762cl1hlyp">
                    {cost.detail}
                  </span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}